// 该文件承担前端 feature flags 与 runtime config 的统一出口。
// 业务模块应消费这里的导出对象，不再直接读取环境变量。

const DEFAULT_SHARED_API_BASE_URL = 'https://api.photoscope.cc';
const DEFAULT_ANALYSIS_MOCK_SCENARIOS = Object.freeze([
  'upload_default_analysis',
  'history_subject_first'
]);
const DEFAULT_ANALYSIS_MOCK_DELAY_MS = 500;
const DEFAULT_ANALYSIS_MOCK_FAILURE_RATE = 0;
const DEFAULT_ANALYSIS_MOCK_SCOPE = 'ai-job-only';
const DEFAULT_CREDIT_MOCK_SCENARIO = 'success';
const DEFAULT_AI_JOB_POLL_INTERVAL_SECONDS = 40;

// NOTE:
// Vue CLI 下环境变量会在编译时静态注入，运行时动态读取 process.env[key] 往往失效。
// 这里显式声明需要的 key，确保在 Vue CLI 构建器下能稳定拿到值。
const staticEnv = {
  NODE_ENV: process.env.NODE_ENV,

  VUE_APP_UPLOAD_REQUIRE_PRESET_SELECTION: process.env.VUE_APP_UPLOAD_REQUIRE_PRESET_SELECTION,

  VUE_APP_FEATURE_RESULT_TASK_VIEW: process.env.VUE_APP_FEATURE_RESULT_TASK_VIEW,

  VUE_APP_FEATURE_GAP_INSIGHT_ENGINE_V2: process.env.VUE_APP_FEATURE_GAP_INSIGHT_ENGINE_V2,

  VUE_APP_REFERENCE_PREFER_CACHE_READ: process.env.VUE_APP_REFERENCE_PREFER_CACHE_READ,

  VUE_APP_INTERNAL_FEATURE_WHITELIST_EMAILS: process.env.VUE_APP_INTERNAL_FEATURE_WHITELIST_EMAILS,

  VUE_APP_INTERNAL_FEATURE_WHITELIST_ENABLED: process.env.VUE_APP_INTERNAL_FEATURE_WHITELIST_ENABLED,

  VUE_APP_FEATURE_CREDIT_GOVERNANCE_V094: process.env.VUE_APP_FEATURE_CREDIT_GOVERNANCE_V094,

  VUE_APP_FEATURE_CREDIT_MOCK_MODE: process.env.VUE_APP_FEATURE_CREDIT_MOCK_MODE,

  VUE_APP_FEATURE_CREDIT_MOCK_SCENARIO: process.env.VUE_APP_FEATURE_CREDIT_MOCK_SCENARIO,

  VUE_APP_API_BASE_URL: process.env.VUE_APP_API_BASE_URL,

  VUE_APP_IMAGE_PUBLIC_BASE_URL: process.env.VUE_APP_IMAGE_PUBLIC_BASE_URL,

  VUE_APP_ANALYSIS_API_BASE_URL: process.env.VUE_APP_ANALYSIS_API_BASE_URL,

  VUE_APP_PAYMENT_API_BASE_URL: process.env.VUE_APP_PAYMENT_API_BASE_URL,

  VUE_APP_CREDIT_API_BASE_URL: process.env.VUE_APP_CREDIT_API_BASE_URL,

  VUE_APP_ANALYSIS_MOCK_ENABLED: process.env.VUE_APP_ANALYSIS_MOCK_ENABLED,

  VUE_APP_ANALYSIS_MOCK_SCENARIOS: process.env.VUE_APP_ANALYSIS_MOCK_SCENARIOS,

  VUE_APP_ANALYSIS_MOCK_DELAY: process.env.VUE_APP_ANALYSIS_MOCK_DELAY,

  VUE_APP_ANALYSIS_MOCK_FAILURE_RATE: process.env.VUE_APP_ANALYSIS_MOCK_FAILURE_RATE,

  VUE_APP_ANALYSIS_MOCK_SCOPE: process.env.VUE_APP_ANALYSIS_MOCK_SCOPE,

  VUE_APP_CREDIT_MOCK_ENABLED: process.env.VUE_APP_CREDIT_MOCK_ENABLED,

  VUE_APP_CREDIT_MOCK_SCENARIO: process.env.VUE_APP_CREDIT_MOCK_SCENARIO,

  VITE_FEATURE_PERMISSION_ALPHA: process.env.VITE_FEATURE_PERMISSION_ALPHA,

  VUE_APP_SUPABASE_URL: process.env.VUE_APP_SUPABASE_URL,

  VUE_APP_SUPABASE_ANON_KEY: process.env.VUE_APP_SUPABASE_ANON_KEY,

  VUE_APP_GOOGLE_CLIENT_ID: process.env.VUE_APP_GOOGLE_CLIENT_ID,

  VUE_APP_GA_MEASUREMENT_ID: process.env.VUE_APP_GA_MEASUREMENT_ID,

  VUE_APP_ANALYTICS_DEBUG: process.env.VUE_APP_ANALYTICS_DEBUG,

  VUE_APP_PLATFORM: process.env.VUE_APP_PLATFORM,

  EXTENSION_TYPE: process.env.EXTENSION_TYPE,

  VITE_PRESET_ANALYSIS_CORE_ENDPOINT: process.env.VITE_PRESET_ANALYSIS_CORE_ENDPOINT,

  VUE_APP_AI_JOB_POLL_INTERVAL_SECONDS: process.env.VUE_APP_AI_JOB_POLL_INTERVAL_SECONDS,

  VUE_APP_LANDING_VERSION_PREVIEW_ENABLED: process.env.VUE_APP_LANDING_VERSION_PREVIEW_ENABLED,

  // Blog 草稿预览开关：仅内部评审预览构建开启，正式生产构建必须为 false。
  VUE_APP_BLOG_PREVIEW_DRAFTS: process.env.VUE_APP_BLOG_PREVIEW_DRAFTS,

  // Mask 渲染运行时（§1.4.4）：字节预算 + 条目数双限制 LRU
  VUE_APP_MASK_RUNTIME_PROFILE: process.env.VUE_APP_MASK_RUNTIME_PROFILE,
  VUE_APP_MASK_RENDER_MAX_EDGE_MOBILE: process.env.VUE_APP_MASK_RENDER_MAX_EDGE_MOBILE,
  VUE_APP_MASK_RENDER_MAX_EDGE_DESKTOP: process.env.VUE_APP_MASK_RENDER_MAX_EDGE_DESKTOP,
  VUE_APP_MASK_SOURCE_CACHE_MOBILE_MB: process.env.VUE_APP_MASK_SOURCE_CACHE_MOBILE_MB,
  VUE_APP_MASK_SOURCE_CACHE_DESKTOP_MB: process.env.VUE_APP_MASK_SOURCE_CACHE_DESKTOP_MB,
  VUE_APP_MASK_SOURCE_CACHE_MOBILE_ENTRIES: process.env.VUE_APP_MASK_SOURCE_CACHE_MOBILE_ENTRIES,
  VUE_APP_MASK_SOURCE_CACHE_DESKTOP_ENTRIES: process.env.VUE_APP_MASK_SOURCE_CACHE_DESKTOP_ENTRIES,
  VUE_APP_MASK_RESULT_CACHE_MOBILE_MB: process.env.VUE_APP_MASK_RESULT_CACHE_MOBILE_MB,
  VUE_APP_MASK_RESULT_CACHE_DESKTOP_MB: process.env.VUE_APP_MASK_RESULT_CACHE_DESKTOP_MB,
  VUE_APP_MASK_RESULT_CACHE_MOBILE_ENTRIES: process.env.VUE_APP_MASK_RESULT_CACHE_MOBILE_ENTRIES,
  VUE_APP_MASK_RESULT_CACHE_DESKTOP_ENTRIES: process.env.VUE_APP_MASK_RESULT_CACHE_DESKTOP_ENTRIES,

  // v2.1.13：首次积分发放弹窗 + 未消费提醒 前端开关
  VUE_APP_FEATURE_TRIAL_CREDITS_NOTICE: process.env.VUE_APP_FEATURE_TRIAL_CREDITS_NOTICE
};

const normalizeKeys = (keys) => (Array.isArray(keys) ? keys : [keys]);

const readEnvValue = (keys) => {
  for (const key of normalizeKeys(keys)) {
    if (Object.prototype.hasOwnProperty.call(staticEnv, key) && staticEnv[key] !== undefined) {
      return staticEnv[key];
    }
  }

  return undefined;
};

const readBooleanEnv = (keys, defaultValue = false) => {
  const value = readEnvValue(keys);
  if (value === undefined || value === null || value === '') {
    return defaultValue;
  }

  const normalizedValue = String(value).trim().toLowerCase();
  return normalizedValue !== 'false' && normalizedValue !== '0';
};

const readNumberEnv = (keys, defaultValue) => {
  const value = readEnvValue(keys);
  if (value === undefined || value === null || value === '') {
    return defaultValue;
  }

  const parsedValue = Number(value);
  return Number.isFinite(parsedValue) ? parsedValue : defaultValue;
};

const readStringEnv = (keys, defaultValue = '') => {
  const value = readEnvValue(keys);
  if (value === undefined || value === null) {
    return defaultValue;
  }

  const normalizedValue = String(value).trim();
  return normalizedValue === '' ? defaultValue : normalizedValue;
};

const readListEnv = (keys, defaultValue = []) => {
  const value = readStringEnv(keys, '');
  if (!value) {
    return [...defaultValue];
  }

  const resolvedList = value
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean);

  return resolvedList.length > 0 ? resolvedList : [...defaultValue];
};

const freezeList = (list) => Object.freeze([...list]);

const normalizeEmailList = (list) => list
  .map((item) => String(item || '').trim().toLowerCase())
  .filter(Boolean);

const maskSecret = (value) => {
  if (!value) {
    return undefined;
  }

  return '***';
};

const resolveNodeEnv = () => readStringEnv(['NODE_ENV'], 'development');

const nodeEnv = resolveNodeEnv();
const isProduction = nodeEnv.toLowerCase() === 'production';
const isDevelopment = nodeEnv.toLowerCase() === 'development';

export const runtimeEnv = Object.freeze({
  nodeEnv,
  isDevelopment,
  isProduction,
  shouldLogConfigSnapshot: !isProduction
});

const resolvedCreditMockMode = readBooleanEnv([
  'VUE_APP_CREDIT_MOCK_ENABLED',
  'VUE_APP_FEATURE_CREDIT_MOCK_MODE'
], true);

const resolvedCreditMockScenario = readStringEnv([
  'VUE_APP_CREDIT_MOCK_SCENARIO',
  'VUE_APP_FEATURE_CREDIT_MOCK_SCENARIO'
], DEFAULT_CREDIT_MOCK_SCENARIO);

export const featureFlags = Object.freeze({
  uploadRequirePresetSelection: readBooleanEnv([
    'VUE_APP_UPLOAD_REQUIRE_PRESET_SELECTION'
  ], true),
  featureResultTaskView: readBooleanEnv([
    'VUE_APP_FEATURE_RESULT_TASK_VIEW'
  ], true),
  featureGapInsightEngineV2: readBooleanEnv([
    'VUE_APP_FEATURE_GAP_INSIGHT_ENGINE_V2'
  ], true),
  referencePreferCacheRead: readBooleanEnv([
    'VUE_APP_REFERENCE_PREFER_CACHE_READ'
  ], false),
  featureCreditGovernanceV094: readBooleanEnv([
    'VUE_APP_FEATURE_CREDIT_GOVERNANCE_V094'
  ], false),
  // v2.1.13：首次积分发放弹窗 + 未消费提醒 前端开关（灰度/熔断）。
  // 默认 true（beta 自动启用）；线上灰度可通过 VUE_APP_FEATURE_TRIAL_CREDITS_NOTICE=false 关闭。
  trialCreditsNoticeEnabled: readBooleanEnv([
    'VUE_APP_FEATURE_TRIAL_CREDITS_NOTICE'
  ], true),
  featureCreditMockMode: resolvedCreditMockMode,
  featureCreditMockScenario: resolvedCreditMockScenario,
  featurePermissionAlpha: readBooleanEnv([
    'VITE_FEATURE_PERMISSION_ALPHA'
  ], false)
});

export const appApiRuntime = Object.freeze({
  baseURL: readStringEnv([
    'VUE_APP_API_BASE_URL'
  ], DEFAULT_SHARED_API_BASE_URL)
});

// SEC-01 S7/S8：公开图片读取基址（非敏感，仅用于拼接资源公开 URL）。
// 与对象存储凭证完全隔离，不持有任何 R2 凭证。
// URL 拼接只读取该单一来源；缺失/非法基址在需要拼 URL 时 fail-closed，不生成 undefined/... URL。
export const imagePublicRuntime = Object.freeze({
  baseURL: readStringEnv([
    'VUE_APP_IMAGE_PUBLIC_BASE_URL'
  ], '')
});

const ensureTrailingSlash = (value) => {
  if (!value || typeof value !== 'string') {
    return value;
  }
  return value.endsWith('/') ? value : `${value}/`;
};

// 由后端 resource_key 与非敏感公开基址生成标准公开 URL。
// 必须使用标准 URL 拼接（URL 构造器自动单斜杠规范化），避免字符串直接相加造成缺失/重复 /。
export const buildImagePublicUrl = (resourceKey) => {
  const baseURL = imagePublicRuntime.baseURL;
  if (!baseURL || !resourceKey) {
    throw new Error('invalid_image_public_base_url');
  }
  try {
    return new URL(resourceKey, ensureTrailingSlash(baseURL)).toString();
  } catch (error) {
    throw new Error('invalid_image_public_base_url');
  }
};

export const aiJobRuntime = Object.freeze({
  pollIntervalSeconds: readNumberEnv([
    'VUE_APP_AI_JOB_POLL_INTERVAL_SECONDS'
  ], DEFAULT_AI_JOB_POLL_INTERVAL_SECONDS)
});

export const internalFeatureRuntime = Object.freeze({
  whitelistEnabled: readBooleanEnv([
    'VUE_APP_INTERNAL_FEATURE_WHITELIST_ENABLED'
  ], false),
  whitelistEmails: freezeList(normalizeEmailList(readListEnv([
    'VUE_APP_INTERNAL_FEATURE_WHITELIST_EMAILS'
  ], [])))
});

const resolveAnalysisMockScope = () => {
  const scope = readStringEnv(['VUE_APP_ANALYSIS_MOCK_SCOPE'], DEFAULT_ANALYSIS_MOCK_SCOPE);
  const validScopes = ['all', 'ai-job-only'];
  return validScopes.includes(scope) ? scope : DEFAULT_ANALYSIS_MOCK_SCOPE;
};

export const analysisMockRuntime = Object.freeze({
  enabled: readBooleanEnv([
    'VUE_APP_ANALYSIS_MOCK_ENABLED'
  ], false),
  scenarios: freezeList(readListEnv([
    'VUE_APP_ANALYSIS_MOCK_SCENARIOS'
  ], DEFAULT_ANALYSIS_MOCK_SCENARIOS)),
  delayMs: readNumberEnv([
    'VUE_APP_ANALYSIS_MOCK_DELAY'
  ], DEFAULT_ANALYSIS_MOCK_DELAY_MS),
  failureRate: readNumberEnv([
    'VUE_APP_ANALYSIS_MOCK_FAILURE_RATE'
  ], DEFAULT_ANALYSIS_MOCK_FAILURE_RATE),
  mockScope: resolveAnalysisMockScope()
});

export const creditMockRuntime = Object.freeze({
  enabled: resolvedCreditMockMode,
  scenario: resolvedCreditMockScenario
});

export const analysisApiRuntime = Object.freeze({
  baseURL: readStringEnv([
    'VUE_APP_ANALYSIS_API_BASE_URL',
    'VUE_APP_API_BASE_URL'
  ], DEFAULT_SHARED_API_BASE_URL),
  mockEnabled: analysisMockRuntime.enabled,
  mockScenarios: analysisMockRuntime.scenarios,
  mockDelayMs: analysisMockRuntime.delayMs,
  mockFailureRate: analysisMockRuntime.failureRate,
  mockScope: analysisMockRuntime.mockScope
});

export const presetAnalysisRuntime = Object.freeze({
  endpoint: readStringEnv([
    'VITE_PRESET_ANALYSIS_CORE_ENDPOINT'
  ], '/api/preset-analysis/core')
});

const paymentPaymentsBaseURL = readStringEnv([
  'VUE_APP_PAYMENT_API_BASE_URL'
], `${appApiRuntime.baseURL}/payments`);

// PAY-06：外跳 URL 纵深防御的 host allowlist。
// 优先级：环境变量覆盖 > 自有支付域名 host > Stripe 官方主机 > stripe.example（测试/e2e 用）。
// stripe.example 为 IANA 保留示例域，不解析到真实攻击者主机，纳入仅用于本地/CI 测试，不构成开放重定向风险。
const resolveRedirectAllowedHosts = (baseUrl) => {
  const envHosts = readListEnv(['VUE_APP_PAYMENT_REDIRECT_ALLOWED_HOSTS'], []);
  const baseHosts = [];
  try {
    const host = new URL(baseUrl).host;
    if (host) {
      baseHosts.push(host);
    }
  } catch (error) {
    // 配置非法 base URL 时忽略，不阻断构建
  }

  const stripeHosts = ['checkout.stripe.com', 'pay.stripe.com', 'billing.stripe.com'];
  const exampleHosts = ['stripe.example'];
  return freezeList([...new Set([...envHosts, ...baseHosts, ...stripeHosts, ...exampleHosts])]);
};

export const paymentApiRuntime = Object.freeze({
  baseURL: appApiRuntime.baseURL,
  paymentsBaseURL: paymentPaymentsBaseURL,
  redirectAllowedHosts: resolveRedirectAllowedHosts(paymentPaymentsBaseURL)
});

export const creditApiRuntime = Object.freeze({
  baseURL: readStringEnv([
    'VUE_APP_CREDIT_API_BASE_URL'
  ], `${appApiRuntime.baseURL}/payments/credits`),
  mockMode: creditMockRuntime.enabled,
  mockScenario: creditMockRuntime.scenario
});

export const supabaseRuntime = Object.freeze({
  url: readStringEnv([
    'VUE_APP_SUPABASE_URL'
  ], ''),
  anonKey: readStringEnv([
    'VUE_APP_SUPABASE_ANON_KEY'
  ], '')
});

export const authRuntime = Object.freeze({
  googleClientId: readStringEnv([
    'VUE_APP_GOOGLE_CLIENT_ID'
  ], '')
});

export const gaRuntime = Object.freeze({
  measurementId: readStringEnv([
    'VUE_APP_GA_MEASUREMENT_ID'
  ], '')
});

export const analyticsRuntime = Object.freeze({
  debugEnabled: readBooleanEnv([
    'VUE_APP_ANALYTICS_DEBUG'
  ], false)
});

export const extensionRuntime = Object.freeze({
  platform: readStringEnv([
    'VUE_APP_PLATFORM'
  ], ''),
  type: readStringEnv([
    'EXTENSION_TYPE'
  ], 'remote')
});

// Landing 版本预览开关：开发环境默认允许 query 切换，生产/预览构建默认禁止。
// 显式配置 VUE_APP_LANDING_VERSION_PREVIEW_ENABLED 可覆盖默认值。
export const landingPreviewRuntime = Object.freeze({
  allowVersionQuery: readBooleanEnv([
    'VUE_APP_LANDING_VERSION_PREVIEW_ENABLED'
  ], runtimeEnv.isDevelopment)
});

// Blog 草稿预览运行时：内部评审预览构建开启，允许草稿详情可达并随构建产物发布草稿正文；
// 正式生产构建必须为 false（生产预览开关由 vue.config.js 直接抛错拦截）。
export const blogPreviewRuntime = Object.freeze({
  enabled: readBooleanEnv([
    'VUE_APP_BLOG_PREVIEW_DRAFTS'
  ], false)
});

// §1.4.4 Mask 渲染运行时：字节预算 + 条目数双限制 LRU（Step C）。
// 业务模块消费本对象，不直接读 process.env。Capacitor 生产构建必须显式配置 mobile。
const resolveMaskRuntimeProfile = () => {
  const configured = readStringEnv(['VUE_APP_MASK_RUNTIME_PROFILE'], 'auto').toLowerCase();
  if (configured === 'mobile' || configured === 'desktop') {
    return configured;
  }
  // auto：优先按平台环境变量判定，否则按视口宽度（仅浏览器，SSR/测试无 matchMedia 时回退 desktop）。
  const platform = readStringEnv(['VUE_APP_PLATFORM'], '').toLowerCase();
  if (platform === 'ios' || platform === 'android' || platform === 'mobile') {
    return 'mobile';
  }
  if (typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    && window.matchMedia('(max-width: 768px)').matches) {
    return 'mobile';
  }
  return 'desktop';
};

const resolveMaskBytesMB = (keys, defaultValue) => {
  const mb = readNumberEnv(keys, defaultValue);
  return Number.isFinite(mb) && mb > 0 ? Math.floor(mb) * 1024 * 1024 : 0;
};
const resolveMaskEntries = (keys, defaultValue) => {
  const n = readNumberEnv(keys, defaultValue);
  return Number.isFinite(n) && n > 0 ? Math.max(1, Math.floor(n)) : 1;
};
const resolveMaskEdge = (keys, defaultValue) => {
  const n = readNumberEnv(keys, defaultValue);
  return Number.isFinite(n) && n > 0 ? Math.max(1, Math.floor(n)) : 1;
};

const maskProfileName = resolveMaskRuntimeProfile();

export const maskRenderRuntime = Object.freeze({
  profile: maskProfileName,
  mobile: Object.freeze({
    renderMaxEdge: resolveMaskEdge(['VUE_APP_MASK_RENDER_MAX_EDGE_MOBILE'], 4096),
    sourceCacheMaxBytes: resolveMaskBytesMB(['VUE_APP_MASK_SOURCE_CACHE_MOBILE_MB'], 64),
    sourceCacheMaxEntries: resolveMaskEntries(['VUE_APP_MASK_SOURCE_CACHE_MOBILE_ENTRIES'], 2),
    resultCacheMaxBytes: resolveMaskBytesMB(['VUE_APP_MASK_RESULT_CACHE_MOBILE_MB'], 32),
    resultCacheMaxEntries: resolveMaskEntries(['VUE_APP_MASK_RESULT_CACHE_MOBILE_ENTRIES'], 2)
  }),
  desktop: Object.freeze({
    renderMaxEdge: resolveMaskEdge(['VUE_APP_MASK_RENDER_MAX_EDGE_DESKTOP'], 8192),
    sourceCacheMaxBytes: resolveMaskBytesMB(['VUE_APP_MASK_SOURCE_CACHE_DESKTOP_MB'], 128),
    sourceCacheMaxEntries: resolveMaskEntries(['VUE_APP_MASK_SOURCE_CACHE_DESKTOP_ENTRIES'], 2),
    resultCacheMaxBytes: resolveMaskBytesMB(['VUE_APP_MASK_RESULT_CACHE_DESKTOP_MB'], 64),
    resultCacheMaxEntries: resolveMaskEntries(['VUE_APP_MASK_RESULT_CACHE_DESKTOP_ENTRIES'], 4)
  })
});

export const maskRuntimeProfile = maskRenderRuntime.profile;

const logFeatureFlagsSnapshot = (snapshot) => {
  if (!runtimeEnv.shouldLogConfigSnapshot) {
    return;
  }

  if (typeof globalThis !== 'undefined' && globalThis.__FEATURE_FLAGS_LOGGED__) {
    return;
  }

  if (typeof globalThis !== 'undefined') {
    globalThis.__FEATURE_FLAGS_LOGGED__ = true;
  }

  console.info('[feature-flags] resolved snapshot', snapshot);
};

export const uploadRequirePresetSelection = featureFlags.uploadRequirePresetSelection;
export const featureResultTaskView = featureFlags.featureResultTaskView;
export const featureGapInsightEngineV2 = featureFlags.featureGapInsightEngineV2;
export const referencePreferCacheRead = featureFlags.referencePreferCacheRead;
export const featureCreditGovernanceV094 = featureFlags.featureCreditGovernanceV094;
export const trialCreditsNoticeEnabled = featureFlags.trialCreditsNoticeEnabled;
export const featureCreditMockMode = featureFlags.featureCreditMockMode;
export const featureCreditMockScenario = featureFlags.featureCreditMockScenario;
export const featurePermissionAlpha = featureFlags.featurePermissionAlpha;

logFeatureFlagsSnapshot({
  runtimeEnv,
  featureFlags: {
    ...featureFlags,
    featurePermissionAlpha
  },
  appApiRuntime,
  analysisApiRuntime,
  paymentApiRuntime,
  creditApiRuntime,
  authRuntime: {
    googleClientId: maskSecret(authRuntime.googleClientId)
  },
  analysisMockRuntime,
  creditMockRuntime,
  maskRenderRuntime
});
